<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>Da li ste sigurni da želite da obrišete obavezu?</p>
    </div>
    <hr />
    <div class="footer">
      <button
        type="submit"
        class="btn btn-default btn--mod close-btn"
        @click="closeModal"
      >
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-danger btn--mod"
        @click="deleteExpense"
        :disabled="loading"
      >
        <p v-if="!loading">Potvrdi</p>
        <spinner :size="20" line-fg-color="#610d0d" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import { financesInstance } from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('modal', ['expense']),
    ...mapState('finances', ['expenses'])
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('finances', ['getTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    deleteExpense() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      financesInstance
        .delete(
          `communities/${
            this.$store.getters.getActiveCommunity.community_id
          }/expenses/${this.expense.id}`
        )
        .then(async () => {
          await this.getTableData({
            communityId: this.$store.getters.getActiveCommunity.id,
            tableName: 'expenses'
          });
          this.setTableData(this.expenses.data);
          this.loading = false;
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(() => {
          this.loading = false;
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped>
.close-btn {
  margin-right: 4px;
}
.btn--mod {
  height: 35px;
  min-width: 75px;
  margin-left: 5px;
  align-self: center;
}
</style>
